const isLocal = window.location.hostname === 'localhost';

const config = {
  API_BASE_URL: isLocal ? 'https://crm-tkxn.onrender.com' : 'https://crm-tkxn.onrender.com',
};

export default config;

